export const LANGUAGES = [
    { 
        name: "en-US"
    },
    { 
        name: "th-TH"
    }
];

export const RESOURCES_PATH: string = "assets/resources";
export const RESOURCES_DATA = { };


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_custom/models/translation.ts